import api from "../api";

export type BadgeStatus = "earned" | "in_progress" | "locked";

export type TrustBadgeKey =
  | "verified_operator"
  | "experienced"
  | "reliable"
  | "top_rated";

export interface TrustBadge {
  key: TrustBadgeKey;
  status: BadgeStatus;
  progress_percent: number;
  detail: string;
}

export interface LoyaltyTierRange {
  tier: string;
  min_points: number;
  max_points: number | null;
}

export interface RecentReview {
  id: number;
  rating: number;
  comment: string | null;
  is_verified: boolean;
  created_at: string;
}

export interface ReputationSummary {
  reputation: {
    score: number;
    total_ratings_count: number;
    is_verified: boolean;
  };
  stats: {
    completed_jobs: number;
    verified_reviews: number;
    on_time_rate: number;
    cancellation_rate: number;
  };
  loyalty: {
    points: number;
    tier: string;
    next_tier: string | null;
    next_tier_points: number | null;
    points_to_next_tier: number;
    progress_percent: number;
    tiers: LoyaltyTierRange[];
  };
  badges: TrustBadge[];
  recent_reviews: RecentReview[];
}

class ReputationService {
  async getSummary(): Promise<ReputationSummary> {
    const response = await api.get<{ data: ReputationSummary }>("/reputation");

    return response.data.data;
  }
}

export default new ReputationService();
